import { Vec2 } from './vec2';
import { Vec3 } from './vec3';
export class Transform {
    constructor() {
        this.position = new Vec2(0, 0);
        this.scale = new Vec2(0, 0);
        this.rotation = new Vec3(0, 0, 0);
        this.origin = new Vec2(0, 0);
    }
}
//# sourceMappingURL=Transform.js.map